<template>
    <div class="fixed z-1000 inset-0 overflow-y-scroll sm:px-2">
        <div class="flex min-h-auto align-top justify-center pt-4 mt-10 px-4 pb-20 sm:p-0">
            <div class="fixed inset-0 transition-opacity">
                <div class="absolute inset-0 bg-black opacity-50"></div>
            </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen md:h-auto"></span>&#8203;

            <div class="h-auto bg-white rounded text-left shadow-xl transform transition-all sm:my-8 sm:align-middle md:align-top"
                 role="dialog" aria-modal="true" aria-labelledby="modal-headline" style="width: 700px;">
                <!--header-->
                <div class="flex py-2 justify-between items-center bg-gray-100 rounded-t-lg w-100%">
                    <h2 class="px-5 text-md font-medium">Create a New User</h2>
                    <button class="mr-4 font-thin text-lg text-gray-500 hover:text-blue-500" @click="closeForm">x</button>
                </div>

              <!--content/body-->
                <div class="w-100% p-5">
                    <form class="">
                        <div class="grid grid-cols-6 gap-6">
                            <div class="col-span-6">
                                <label for="role" class="block text-sm font-medium leading-5 text-gray-700">Role</label>
                                <select id="role"
                                        v-model="form.role"
                                        @change="roleChanged"
                                        class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-400 focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                        <option value="" disabled selected>Select Role</option>
                                        <option v-for="role in roles">{{ role }}</option>
                                </select>
                                <span class="invalid-feedback" :class="{'d-block': form.errors.has('role')}"
                                      v-show="form.errors.has('role')">{{ form.errors.get("role") }}
                                </span>
                            </div>

                            <div class="col-span-6 md:col-span-3">
                                <label for="first_name" class="block text-sm font-medium leading-5 text-gray-700">First name</label>
                                <input id="first_name"
                                       v-model="form.first_name"
                                       :class="{'is-invalid': form.errors.has('first_name')}"
                                       class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-400 focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                <span class="invalid-feedback" v-show="form.errors.has('first_name')">{{ form.errors.get("first_name") }}</span>
                            </div>

                            <div class="col-span-6 md:col-span-3">
                                <label for="last_name" class="block text-sm font-medium leading-5 text-gray-700">Last name</label>
                                <input id="last_name"
                                       v-model="form.last_name"
                                       :class="{'is-invalid': form.errors.has('last_name')}"
                                       class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-400 focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                <span class="invalid-feedback" v-show="form.errors.has('last_name')">{{ form.errors.get("last_name") }}</span>
                            </div>


                             <div class="col-span-6 md:col-span-3">
                                <label for="email" class="block text-sm font-medium leading-5 text-gray-700">Email</label>
                                <input id="email"
                                       v-model="form.email"
                                       :class="{'is-invalid': form.errors.has('email')}"
                                       class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-400 focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                <span class="invalid-feedback" v-show="form.errors.has('email')">{{ form.errors.get("email") }}</span>
                            </div>

                            <div class="col-span-6 md:col-span-3">
                                <label for="mobile" class="block text-sm font-medium leading-5 text-gray-700">Mobile</label>
                                <input id="mobile"
                                       v-model="form.mobile"
                                       type="tel"
                                       :class="{'is-invalid': form.errors.has('mobile')}"
                                       class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-400 focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                <span class="invalid-feedback" v-show="form.errors.has('mobile')">{{ form.errors.get("mobile") }}</span>
                            </div>

                            <div v-if="showMailboxField" class="col-span-6">
                                <label for="mailbox" class="block text-sm font-medium leading-5 text-gray-700">Mailbox</label>
                                <select id="mailbox"
                                        placeholder="Select Mailbox"
                                        v-model="form.mailbox"
                                        class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-400 focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                                        <option value="" disabled selected>Select Mailbox</option>
                                        <option v-for="mailbox in mailboxes" :value="mailbox.id" @change="roleChanged">{{ mailbox.name }}</option>
                                </select>
                                <span class="invalid-feedback" :class="{'d-block': form.errors.has('mailbox')}"
                                      v-show="form.errors.has('mailbox')">{{ form.errors.get("mailbox") }}
                                </span>
                            </div>

                            <div class="col-span-6">
                                <label class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input"
                                           v-model="form.send_invite"/>
                                   <span class="custom-control-label">Send an invite email <small
                                       class="text-muted align-top"><br/> An invite can be sent later if you aren't ready</small></span>
                                </label>
                            </div>

                        </div>
                        <div class="flex justify-end">
                            <a @click="$emit('close')"
                               class="btn btn-link waves-effect waves-light mt-4">
                                Cancel
                            </a>
                            <button :disabled="form.busy" type="submit"
                                    class="btn btn-primary waves-effect waves-light mt-4"
                                    @click.prevent="createUser">
                                {{ form.busy ? "Creating..." : "Create" }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["team", "roles", "mailboxes"],

  data () {
    return {
      form: new AppForm({
        role: "",
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        mailbox: "",
        send_invite: false,
      }),
    };
  },

  // can unfortunately not used Mounted here :(, otherwise the Roles array is still empty.
  beforeUpdate () {
    this.selectFirstRoleWhenTenantOrLandLord();
  },

  computed: {
    showMailboxField () {
      return this.form.role != "Landlord" && this.form.role != "Tenant";
    }
  },

  methods: {
    createUser () {

      App.post("/" + this.team.id + "/users/store", this.form)
      .then((response) => {
        if (response.status && response.status !== 200) {
          toastr.error(response.message);
        } else {
          toastr.success("New user created! Redirecting...");
          Bus.$emit("user-created");
          window.location = response.redirect;
        }
      }).catch(errors => {
        toastr.error(errors.message);
      });
    },

    roleChanged () {
      if ("Account Owner" === this.form.role) {
        swal({
          title: "Make user the " + this.form.role,
          text: "Making this user the " + this.form.role + " will change your role to Manager. The user will be given full account ownership and permissions.",
          showCancelButton: false
        });
      }
    },

    selectFirstRoleWhenTenantOrLandLord () {
      // select first role when this.roles is an array
      this.roles.length === 1 ? this.form.role = _.capitalize(this.roles[0]) : null;
    },

    closeForm () {
      this.role = [];
      this.$emit("close");
    }

  }
};
</script>

<style scoped>

</style>
